import { motion } from "framer-motion";
import { KEY_INTEGRATION_AREAS, IMAGES } from "@/data/content";

export const SystemIntegration = () => (
  <section data-testid="system-integration-section" className="bg-surfaceLight px-6 py-[30px] sm:py-[32px] lg:px-12 lg:py-[56px]">
    <div className="lg:mx-auto lg:max-w-[1280px]">
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-16">
        <motion.div
          initial={{ opacity: 0, scale: 0.98 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="lg:col-span-6"
        >
          <div data-testid="system-integration-visual" className="h-[280px] w-full overflow-hidden rounded-2xl sm:h-[340px] lg:h-[374px]">
            <img
              src={IMAGES.systemIntegrationPhoto}
              alt="Solar, wind, battery and hydrogen storage equipment integrated on a farm site"
              className="h-full w-full object-cover"
            />
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          className="lg:col-span-6"
        >
          <h2
            data-testid="system-integration-headline"
            className="font-heading text-[28px] font-semibold leading-tight text-ink sm:text-[32px] lg:text-[36px]"
          >
            Designed to work
            <br className="sm:hidden" /> as one system
          </h2>
          <p data-testid="system-integration-text" className="mt-[32px] lg:mt-5 text-[15px] leading-relaxed text-inkSoft">
            Off-Grid Hydrogen integrates commercially available solar, wind, battery and
            hydrogen technologies into a coordinated agricultural energy system. The core
            architecture is repeatable, but the final configuration — equipment sizing,
            storage duration and controls — is confirmed through site-specific engineering
            based on measured loads, renewable resources and backup requirements.
          </p>

          <div data-testid="system-integration-list" className="mt-7 divide-y divide-borderLight border-t border-borderLight">
            {KEY_INTEGRATION_AREAS.map((item, i) => (
              <div key={item} data-testid={`system-integration-item-${i}`} className="py-4">
                <span className="text-base text-ink">{item}</span>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </div>
  </section>
);
